module.exports = __webpack_public_path__ + "images/Medications_SS_739694626_5af4971.jpg";